/* eslint-disable */
import Oidc from "oidc-client";
import LogRocket from "logrocket";
import { buildLogoutUrl } from "./logoutUrl";

const authority = process.env.OIDC_AUTHORITY;
const client_id = process.env.OIDC_CLIENT_ID;
const base_url = process.env.OIDC_BASE_URI;
const response_type = "id_token token";
const scope = "openid profile groups";
// Must be listed in the Auth0 application's Allowed Logout URLs.
const logout_return_to = window.location.origin + "/";

var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore(),
  authority: authority,
  client_id: client_id,
  redirect_uri: window.location.origin + "/callback.html",
  response_type: response_type,
  scope: scope,
  silent_redirect_uri: window.location.origin + "/silent-renew.html",
  revokeAccessTokenOnSignout: false,
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  metadata: {
    authorization_endpoint: base_url + "/authorize",
   }
});

// Set once a logout starts; a late login would replace the logout address in the tab.
let loggingOut = false;

// The store is kept whole in sessionStorage (store/index.js) and survives the trip
// to Auth0 and back, so the next sign in in this tab would start with it.
function forgetSavedState() {
  try {
    window.sessionStorage.clear();
  } catch (e) {}
}

// Auth0 publishes no end session endpoint, so signoutRedirect cannot end its
// session and Auth0 signs the user straight back in. Drop the local user, then
// let Auth0 end its session; it returns the browser to the site root.
function logout() {
  loggingOut = true;
  forgetSavedState();
  // every store update rewrites it, so clear it again as the page goes
  window.addEventListener("pagehide", forgetSavedState);
  const toAuth0 = function() {
    window.location.assign(
      buildLogoutUrl(base_url, client_id, logout_return_to)
    );
  };
  return mgr.removeUser().then(toAuth0, toAuth0);
}

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function(user) {
  console.log("New User Loaded：", arguments);
  LogRocket.identify("THE_USER_ID_IN_YOUR_APP", {
    name: user.profile.name,
    email: user.profile.email,
    environmente: process.env.ENVIRONMENT
  });
});

mgr.events.addAccessTokenExpiring(function() {
  console.log("AccessToken Expiring：", arguments);
});

// An expired token is not a logout: Auth0 keeps its session, so the sign-in
// brings the user back without a password.
// A tab left idle keeps the timer of the user it first read, so check the stored
// user: another tab may have signed in again since.
mgr.events.addAccessTokenExpired(function() {
  console.log("AccessToken Expired：", arguments);
  const signInAgain = function() {
    new SecurityService().signIn();
  };
  mgr.getUser().then(function(user) {
    if (user && !user.expired) return;
    mgr.removeUser().then(signInAgain, signInAgain);
  });
});

mgr.events.addSilentRenewError(function() {
  console.error("Silent Renew Error：", arguments);
});

mgr.events.addUserSignedOut(function() {
  alert("Going out!");
  console.log("UserSignedOut：", arguments);
  logout();
});

export default class SecurityService {
  // Renew the token manually
  renewToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent()
        .then(function(user) {
          if (user == null) {
            self.signIn(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Check if there is any user logged in
  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Redirect of the current window to the authorization endpoint.
  signIn() {
    if (loggingOut) return;
    mgr.signinRedirect().catch(function(err) {
      console.log(err);
    });
  }

  // Sign out of the app and of Auth0
  signOut() {
    logout();
  }

  // Get the profile of the user logged in
  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            LogRocket.identify("THE_USER_ID_IN_YOUR_APP", {
              name: user.profile.name,
              email: user.profile.email,
              environmente: process.env.ENVIRONMENT
            });
            return resolve(user.id_token);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAcessToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user roles logged in
  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.groups);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }
}
